import { Link } from 'react-router-dom';

// components
import AuthLayout from '../auth/AuthLayout';
import { LinkButton } from '_ui/Button';
import { useGo } from '_utils/url';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Error404 = () => {
    const go = useGo();
    // get current path check if has /admin
    const currentPath = window.location.pathname;
    const hasAdmin = currentPath.includes('/admin');
    return (


        <div className="account-pages my-5">
            <Container>
                <Card>
                    <Card.Body className="p-3">
                        <div className="text-center" >
                            <h1 className="text-error">404</h1>
                            <h3 className="mt-3 mb-2">Página não encontrada</h3>
                            <p className="text-muted mb-3">
                                Ops! Parece que você se perdeu. 🧭
                            </p>

                            <LinkButton text='Ir para o início' icon='fa-home' onClick={() => hasAdmin ? go('/admin', 'dashboard') : window.location.pathname = ''} />
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </div>

    );
};

export default Error404;
